<template>
    <div>
        <modal class="check-in" :display="modalStatus.bizCheckIn" @modalStatus="closeModal" >
            <h1 v-if="type === 'CHECK_IN'">入住點交</h1>
            <h1 v-else>入住點交明細</h1>
            <div class="check-in-wrap" :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                <div class="check-in-info">
                    <div class="address">
                        {{contractObj?contractObj.address:''}}
                    </div>
                    <div class="contract-period">
                        租期：{{contractObj?getFormatDateTime(contractObj.contractBeginDate):''}} - {{contractObj?getFormatDateTime(contractObj.contractEndDate):''}}
                    </div>
                    <div class="rent">
                        租金：{{toCurrency(contractObj?contractObj.rentPrice:'')}}
                    </div>
                </div>
                <div class="block" v-if="checkInDetail && checkInDetail.landlordCheckInTime || checkInDetail && checkInDetail.tenantCheckInTime">
                    <div class="title">點交日期</div>
                    <div class="content">
                        <div v-if="checkInDetail.landlordCheckInTime">
                            房東點交日期：{{getFormatDateTime(checkInDetail.landlordCheckInTime)}}
                        </div>
                        <div v-if="checkInDetail.tenantCheckInTime">
                            房客點交日期：{{getFormatDateTime(checkInDetail.tenantCheckInTime)}}
                        </div>
                    </div>
                </div>
                <div class="block">
                    <div class="title">設備傢俱清單</div>
                    <div class="content equipments" v-if="checkInDetail && checkInDetail.equipmentList.length">
                        <div class="equipment" v-for="(item, index) in checkInDetail.equipmentList" :key="index">
                            {{item.itemName}} x {{item.count}}
                        </div>
                    </div>
                    <div class="content" v-else>
                        無
                    </div>
                </div>
                <div class="block">
                    <div class="title">費用設定</div>
                    <div class="content" v-if="checkInDetail && checkInMeterByNull.length">
                        <div class="billCharge" v-for="(item, index) in checkInMeterByNull" :key="index">
                            {{item.itemName}}：{{transType(item.type)}} {{item.amount}} {{item.type!=='PAY_BY_SELF'?'元':''}}
                        </div>
                    </div>
                    <div class="content" v-else>
                        無
                    </div>
                </div>
                <div class="block">
                    <div class="title">入住點交日度數</div>
                    <div class="content" v-if="type === 'CHECK_IN' && checkInDetail && checkInDetail.checkInMeter.length">
                        <div class="input-block" v-for="(item, index) in checkInDetail.checkInMeter" :key="index">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill"></span>
                                    {{item.itemName}}度數
                                </div>
                                <!-- <span v-show="error.totalFloorErr" class="error-with-title">{{error.totalFloorErr}}</span> -->
                            </label>
                            <div class="input-arear">
                                <input type="number" v-model.number="meter[index]" onkeyup="this.value=this.value.replace(/\D/g,'')" placeholder="輸入度數">
                            </div>
                        </div>
                    </div>
                    <div class="content" v-else-if="checkInDetail && checkInDetail.checkInMeter.length">
                        <div class="billCharge" v-for="(item, index) in checkInDetail.checkInMeter" :key="index">
                            {{item.itemName}}：{{item.meter?toCurrency(item.meter):0}} 度
                        </div>
                    </div>
                    <div class="content" v-else>
                        無
                    </div>
                </div>
            </div>
            <div class="btn-group" v-if="type === 'CHECK_IN'">
                <button class="default-button confirm" @click="checkIn()">入住點交</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';

import { mapGetters } from 'vuex'

import { 
    getCheckInPage,
    checkIn
    } from "@/apis/company/leaseMgt.js"; 
import { 
    getCheckInPage as getLandlordCheckInPage,
    checkIn as landlordCheckIn
    } from "@/apis/landlord/leaseMgt.js"; 

export default {
    data () {
        return {
            modalHeight: (window.innerHeight-300) + 'px',
            componentKey: 0,
            checkInDetail: null,
            meter: []
        }
    },
    props:{
        contractObj: {
            type: Object,
            default: null
        },
        type: {
            type: String,
            default: null
        },
        loginType: {
            type: String,
            default: 'COMPANY'
        },
    },
    mounted (){
        window.addEventListener('resize', this.resizeModal)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeModal)
    },
    watch:{
        contractObj: {
            handler: function (val) {
                if(val.contractSeq){
                    this.getCheckInDetail(val.contractSeq)
                }
            },
            deep: true
        },
        checkInDetail: {
            handler: function (val) {
                if(val.checkInMeter.length){
                    for (let i = 0; i < val.checkInMeter.length; i++) {
                        this.meter[i] = null           
                    }
                }
            },
            deep: true
        },
    },
    methods: {
        transType: function (type){
            if(type === 'BY_KILOWATT'){
                return '每度'
            }else if(type === 'BY_MONTH'){
                return '每月'
            }else if(type === 'PAY_BY_SELF'){
                return '依帳單繳交'
            }
        },
        resizeModal: function (){
            let _self = this
            console.log(window.innerHeight)
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-300) + 'px'
                _self.componentKey += 1
            }
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizCheckIn'})
        },
        getCheckInDetail: function (contractSeq) {
            let params = {
                contractSeq: contractSeq
            }
            console.log('start')
            console.log(this.loginType)
            if(this.loginType === 'COMPANY'){
                getCheckInPage(params)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.checkInDetail = res.data.result
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }else if(this.loginType === 'LANDLORD'){
                console.log('getLandlordCheckInPage')
                getLandlordCheckInPage(params)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.checkInDetail = res.data.result
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }
            
        },
        checkIn: function () {
            let data = {
                "contractSeq": this.contractObj.contractSeq,
                "electricityMeter": this.meter[0],
                "waterMeter": this.meter[1],
                "gasMeter": this.meter[2]
            }

            
            if(this.loginType === 'COMPANY'){
                checkIn(data)
                .then(res => {
                    console.log(res)
                    if(res.data.status == "SUCCESS"){
                        this.$store.dispatch('getBizLeaseProcessMgtList')
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '入住點交成功',type: 'success'})
                        this.closeModal()
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '入住點交失敗',type: 'error'})
                    }
                })
                .catch( err => {
                    console.log(err)
                })
            }else if(this.loginType === 'LANDLORD'){
                landlordCheckIn(data)
                .then(res => {
                    console.log(res)
                    if(res.data.status == "SUCCESS"){
                        this.$store.dispatch('getLeaseDoneMgtList')
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '入住點交成功',type: 'success'})
                        this.closeModal()
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '入住點交失敗',type: 'error'})
                    }
                })
                .catch( err => {
                    console.log(err)
                })
            }
        },
    },
    computed: {
        checkInMeterByNull: function () {
            return this.checkInDetail.billChargeMode.filter((item) => {
                if(item.amount != null) return item
            });
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.check-in{
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                }
                .check-in-wrap{
                    padding: 20px 32px 20px;
                    overflow-x: hidden;
                    max-height: 455px;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    .check-in-info{
                        position: relative;
                        width: 384px;
                        padding: 16px;
                        margin-bottom: 24px;
                        border-radius: 6px;
                        box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
                        border: solid 1px #f3f3f3;
                        background-color: #ffffff;
                        box-sizing: border-box;
                        .address{
                            font-size: 16px;
                            font-weight: 500;
                            margin-bottom: 8px;
                        }
                        .contract-period{
                            color: #676362;
                            margin-bottom: 8px;
                        }
                        .rent{
                            color: #676362;
                        }
                    }
                    .block{
                        margin-bottom: 28px;
                        >.title{
                            font-weight: 500;
                            font-size: 16px;
                            color: #ff9275;
                            margin-bottom: 14px;
                        }
                        >.content{
                            .input-block{
                                margin-bottom: 20px;
                            }
                            &.equipments{
                                display: flex;
                                align-items: flex-start;
                                justify-content: space-between;
                                flex-wrap: wrap;
                                .equipment{
                                    width: 128px;
                                    margin-bottom: 10px;
                                }
                            }
                            .billCharge{
                                margin-bottom: 10px;
                            }
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 200px;
                    height: 44px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/checkIn.vue